module.exports = __webpack_public_path__ + "img/mountains.8644ebfe.svg";